module.exports = __webpack_public_path__ + "img/angle_180.f57e579c.jpg";